module.exports = __webpack_public_path__ + "img/model-x-selection3.0294c160.jpg";